(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'number' ? precision : 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) return '0';

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1] ? decimal + parts[1] : '';

      return whole + fraction;
    }

    switch ((formatString.match(placeholderRegex) || [null, 'amount'])[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getScope(node) {
    if (!node || typeof node.closest !== 'function') return document;

    return (
      node.closest('[data-product-form]') ||
      node.closest('.product__form') ||
      node.closest('.product__meta') ||
      node.closest('.shopify-section') ||
      document
    );
  }

  function getQuantityInput(scope) {
    if (!scope || typeof scope.querySelector !== 'function') return null;

    return (
      scope.querySelector('[data-product-form] [data-quantity-input]') ||
      scope.querySelector('[data-quantity-input]')
    );
  }

  function getCurrentQuantity(scope) {
    var input = getQuantityInput(scope);
    if (!input) return 1;

    var qty = parseInt(input.value, 10);
    if (!Number.isFinite(qty) || qty < 1) return 1;

    return qty;
  }

  function setVisibility(root, badge, isVisible) {
    var row = root && typeof root.closest === 'function'
      ? root.closest('.product__purchase-row--cashback')
      : null;

    if (badge) {
      badge.hidden = !isVisible;
    }

    if (root) {
      root.hidden = !isVisible;
    }

    if (row) {
      row.hidden = !isVisible;
    }
  }

  function updateBadge(root, variantId) {
    if (!root) return;

    var badge = root.querySelector('[data-cashback-root]');
    var amountNode = root.querySelector('[data-cashback-amount]');
    var scope = getScope(root);
    var resolvedVariantId = String(variantId || root.dataset.currentVariantId || '');

    if (!badge || !amountNode || !resolvedVariantId) {
      setVisibility(root, badge, false);
      return;
    }

    var variantData = root.querySelector(
      '[data-cashback-variant][data-variant-id="' + resolvedVariantId + '"]'
    );

    if (!variantData) {
      setVisibility(root, badge, false);
      return;
    }

    var variantAvailable = String(variantData.dataset.variantAvailable || 'false') === 'true';
    var basePriceCents = parseInt(variantData.dataset.basePriceCents || '0', 10);
    var cashbackRate = parseFloat(root.dataset.cashbackRate || '0');
    var qty = getCurrentQuantity(scope);

    if (
      !variantAvailable ||
      !Number.isFinite(basePriceCents) ||
      basePriceCents <= 0 ||
      !Number.isFinite(cashbackRate) ||
      cashbackRate <= 0 ||
      !Number.isFinite(qty) ||
      qty < 1
    ) {
      setVisibility(root, badge, false);
      return;
    }

    var cashbackCents = Math.round((basePriceCents * qty * cashbackRate) / 100);

    amountNode.textContent = formatMoney(
      cashbackCents,
      (window.theme && window.theme.moneyFormat) || '${{amount}}'
    );

    root.dataset.currentVariantId = resolvedVariantId;
    setVisibility(root, badge, cashbackCents > 0);
  }

  function initRoot(root) {
    if (!root) return;

    if (root.dataset.cashbackInitialized === 'true') {
      if (root.dataset.currentVariantId) {
        updateBadge(root, root.dataset.currentVariantId);
      }
      return;
    }

    root.dataset.cashbackInitialized = 'true';

    if (root.dataset.currentVariantId) {
      updateBadge(root, root.dataset.currentVariantId);
    }
  }

  function initAll(scope) {
    var container = scope && typeof scope.querySelectorAll === 'function' ? scope : document;

    container.querySelectorAll('[data-cashback-badge-container]').forEach(function (root) {
      initRoot(root);
    });
  }

  function updateAllInScope(scope) {
    var container = scope && typeof scope.querySelectorAll === 'function' ? scope : document;

    container.querySelectorAll('[data-cashback-badge-container]').forEach(function (root) {
      updateBadge(root, root.dataset.currentVariantId || '');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

    document.addEventListener('product:variant-change', function (evt) {
    var variant = evt.detail && evt.detail.variant ? evt.detail.variant : null;
    var variantId = variant && variant.id ? String(variant.id) : '';
    var scopedContainer =
      evt.detail && evt.detail.scope && typeof evt.detail.scope.querySelectorAll === 'function'
        ? evt.detail.scope
        : getScope(evt.target);

    var roots = scopedContainer.querySelectorAll
      ? scopedContainer.querySelectorAll('[data-cashback-badge-container]')
      : [];

    if (!roots.length) {
      roots = document.querySelectorAll('[data-cashback-badge-container]');
    }

    roots.forEach(function (root) {
      var matchingVariant = variantId
        ? root.querySelector(
            '[data-cashback-variant][data-variant-id="' + variantId + '"]'
          )
        : null;

      if (matchingVariant || !variantId) {
        updateBadge(root, variantId);
      }
    });
  });

  document.addEventListener('change', function (evt) {
    if (evt.target && evt.target.matches('[data-quantity-input]')) {
      updateAllInScope(getScope(evt.target));
    }
  });

  document.addEventListener('input', function (evt) {
    if (evt.target && evt.target.matches('[data-quantity-input]')) {
      updateAllInScope(getScope(evt.target));
    }
  });

  document.addEventListener('click', function (evt) {
    var trigger = evt.target && evt.target.closest('[data-add-quantity], [data-subtract-quantity]');
    if (!trigger) return;

    requestAnimationFrame(function () {
      updateAllInScope(getScope(trigger));
    });
  });

  document.addEventListener('quickview:loaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target || document);
  });
})();
